import { render, staticRenderFns } from "./DrawerDetail.vue?vue&type=template&id=0870c806&scoped=true&"
import script from "./DrawerDetail.vue?vue&type=script&lang=js&"
export * from "./DrawerDetail.vue?vue&type=script&lang=js&"
import style0 from "./DrawerDetail.vue?vue&type=style&index=0&id=0870c806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870c806",
  null
  
)

export default component.exports